import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const OrderConfirmed = () => {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);

        const isSuccess = sessionStorage.getItem("order_success");

        if (isSuccess !== "true") {
            navigate("/explore-us", { replace: true });
            return;
        }

        // StrictMode safe remove
        setTimeout(() => {
            sessionStorage.removeItem("order_success");
        }, 100);

    }, [navigate]);

    return (
        <section className="confirm-wrapper">
            <div className="confirm-card">

                {/* ICON */}
                <div className="success-icon">
                    ✅
                </div>

                {/* HEADLINE */}
                <h2 className="confirm-title">
                    অর্ডার সফলভাবে সম্পন্ন হয়েছে
                </h2>

                <p className="confirm-subtitle">
                    Your Order Has Been Successfully Placed
                </p>

                {/* BODY */}
                <p className="confirm-text">
                    ধন্যবাদ! আপনার অর্ডারটি আমরা পেয়েছি। আমাদের একজন প্রতিনিধি খুব শীঘ্রই
                    আপনার সাথে যোগাযোগ করে অর্ডারটি কনফার্ম করবে।
                </p>

                <p className="confirm-text en">
                    Thank you for your order. Our team will contact you shortly
                    to confirm your order.
                </p>

                {/* INFO BOX */}
                <div className="confirm-info">
                    📦 আপনার অর্ডার এখন প্রসেসিং অবস্থায় আছে।
                </div>

                {/* CALL */}
                <div className="confirm-call">
                    জরুরি প্রয়োজনে সরাসরি কল করুন / For urgent support:
                    <br />
                    <a href="tel:01944003077">Call Now : 01944-003077</a>
                </div>

                {/* BUTTON */}
                <Link to="/explore-us" className="confirm-btn">
                    Back To Home
                </Link>

            </div>
        </section>
    );
};

export default OrderConfirmed;